<template>
  <div class="helpContractDetail">
    <help-header />
    <v-divider class="helpContractDetail_divider" />
    <section class="helpContractDetail_content">
      <p>
        {{ currentQuestion.answer }}
      </p>
    </section>
    <v-divider class="helpContractDetail_divider" />

    <h4 class="helpContractDetail-need">サポートが必要ですか？</h4>
    <section class="helpContractDetail-need_box">
      <h3 class="helpContractDetail-need_box-title">お問い合わせ内容</h3>
      <v-textarea
        v-model="input"
        no-resize
        counter
        outlined
        background-color="white"
        placeholder="お問い合わせ内容を入力してください"
        rows="8"
        row-height="40"
        hint=" "
        persistent-hint
      >
        <template #counter="{ props }">
          <h6 class="helpContractList-need_input-bottom_counter">
            <em
              :class="{
                ['error']: props.value > maxInput,
                ['not-exceed']: props.value > 0 && !(props.value > maxInput),
              }"
              >{{ props.value }}</em
            >
            / {{ maxInput }}
          </h6>
          <input
            type="hidden"
            :value="(isDisable = props.value > maxInput || props.value === 0)"
          />
        </template>
        <template #message>
          <h6 class="helpContractList-need_input-bottom_message">
            {{ maxInput }}文字以内
          </h6>
        </template>
      </v-textarea>
      <section v-if="currentTopic.showCamSelect" class="helpContractList-cam">
        <div
          v-ripple
          class="helpContractList-collapse"
          @click="
            navigateTo({
              name: 'help-cam-select',
              params: {
                id: $route.params.id,
                topic: $route.params.topic,
                qid: $route.params.qid,
              },
            })
          "
        >
          <h3>ご質問対象のカメラ</h3>
          <v-icon class="helpContractList-collapse--icon" size="22">
            mdi-chevron-right
          </v-icon>
          <h6>ご質問対象のカメラをカメラ一覧から選択</h6>
          <h4 v-if="selectedCam">{{ selectedCam.name }}</h4>
        </div>
      </section>
      <section
        v-if="currentTopic.showCamSelect"
        class="helpContractList-cam_permission"
        :class="{
          ['helpContractList-cam_permission--disabled']: selectedCam === null,
        }"
      >
        <div class="helpContractList-cam_permission-title">
          <h3>ご質問対象のカメラ</h3>
          <v-switch
            v-model="allowCamSwitch"
            :disabled="selectedCam === null"
            :ripple="false"
            dense
          ></v-switch>
          <h6>オペレーターがカメラ映像を閲覧する事を許可する</h6>
        </div>
      </section>
      <h4 class="helpContractDetail-need_note">
        以下の情報がメールに記載されます
      </h4>
      <section class="helpContractDetail-need_details">
        <section class="helpContractDetail-need_details-item">
          <span class="helpContractDetail-need_details-title">フルネーム</span>
          <p class="helpContractDetail-need_details-text">{{ username }}</p>
        </section>
        <section class="helpContractDetail-need_details-item">
          <span class="helpContractDetail-need_details-title"
            >ユーザーネーム</span
          >
          <p class="helpContractDetail-need_details-text">SECOM ユーザ</p>
        </section>
        <section class="helpContractDetail-need_details-item">
          <span class="helpContractDetail-need_details-title"
            >メールアドレス</span
          >
          <p class="helpContractDetail-need_details-text">{{ userEmail }}</p>
        </section>
        <section class="helpContractDetail-need_details-item">
          <span class="helpContractDetail-need_details-title"
            >お問い合わせの種類</span
          >
          <p class="helpContractDetail-need_details-text">
            {{ currentCategory.title }} - {{ currentTopic.title }}
          </p>
        </section>
      </section>
    </section>

    <v-btn
      class="helpContractDetail-save"
      :disabled="isDisable"
      @click="handleSend"
      >次へ</v-btn
    >
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HelpHeader from '../HelpHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'HelpContractDetail',
  components: {
    HelpHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
      isDisable: false,
      maxInput: 1000,
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
      selectedCam: (state) => state.help.selectedCam,
      allowCam: (state) => state.help.allowCam,
      userInfo: (state) => state.common.userInfo,
    }),
    currentCategory() {
      return this.helpCategories.find(
        (item) => item.id === this.$route.params.id
      );
    },
    currentTopic() {
      return (
        (this.currentCategory.sub_topic || []).find(
          (item) => item.id === this.$route.params.topic
        ) || {}
      );
    },
    questions() {
      return this.currentTopic.list || [];
    },
    currentQuestion() {
      if (!this.questions) return {};

      return (
        (this.questions || []).find(
          (item) => item.id === this.$route.params.qid
        ) || {}
      );
    },
    input: {
      get() {
        if (!this.currentTopic) {
          return '';
        }
        return this.currentTopic.input || '';
      },
      set(newValue) {
        if (!this.currentTopic) {
          return;
        }
        return this.setTopicInput({
          input: newValue,
          categoryId: this.currentCategory.id,
          topicId: this.currentTopic.id,
        });
      },
    },
    username: () => 'セコム 太郎',
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : '';
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  mounted() {
    if (this.$route.query.dl === 1) {
      this.displayDeleteMessage();
    }
  },
  methods: {
    ...mapActions('help', ['setTopicInput']),
    handleSend() {
      this.navigateTo({
        name: 'help-confirm',
        params: {
          id: this.currentCategory.id,
          topic: this.currentTopic.id,
          qid: this.currentQuestion.id,
        },
      });
    },
    navigateTo(route) {
      this.routerPush(route);
    },
    displayDeleteMessage() {
      this.dialogMessageText = 'グループを削除しました。';
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.helpContractDetail {
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &-q_index {
    width: 30px;
    margin-right: 5px;
    display: inline-block;
  }
  &_title {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
  }
  &-need {
    margin-top: 32px;
    margin-bottom: 10px;
    font-size: 14px;
    text-align: left;
    color: #666;
    &_input {
      &-bottom {
        &_message,
        &_counter {
          font-size: 12px;
          text-align: left;
          color: #989898;
        }
        &_counter {
          em {
            &.error {
              color: #eb545b;
              background-color: unset !important;
            }
            &.not-exceed {
              color: #0075c2;
              background-color: unset !important;
            }
          }
        }
      }
    }
    &_note {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-top: 11px;
      border-bottom: 1px solid #eeeeee;
      border-top: 1px solid #eeeeee;
      padding: 10px 0;
    }
    &_box {
      margin-top: 11px;
      box-shadow: 0 1px 0 0 #eee;
      background-color: #f3f3f3;
      padding: 15px;

      .v-textarea {
        &.v-text-field {
          &--outlined:not(.v-input--is-focused):not(.v-input--has-state)
            > .v-input__control
            > .v-input__slot
            fieldset {
            border-radius: 5px;
            border: solid 2px #ccc;
            background-color: #fff;
          }
          &--enclosed {
            .v-text-field__details {
              padding: 0;
            }
            .v-text-field__slot textarea {
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.38;
              letter-spacing: normal;
              text-align: left;
              color: #666;
              &::placeholder {
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.38;
                letter-spacing: normal;
                text-align: left;
                color: #ccc;
              }
            }
          }
        }
      }
      &-title {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        margin-bottom: 10px;
      }
    }
    &_details {
      margin-top: 26px;
      &-item {
        display: flex;
      }
      &-title {
        width: 150px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &-text {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        word-wrap: break-word;
      }
    }
  }
  &-cam {
    border-top: solid 1px #ffffff;
    border-bottom: solid 1px #ffffff;
    padding: 15px 0;

    & > .helpContractList-collapse {
      width: 100%;
    }

    &_permission {
      border-bottom: solid 1px #ffffff;
      padding: 15px 0;
      &--disabled {
        pointer-events: none;
        .helpContractList-cam_permission-title {
          h3,
          h6 {
            color: #ccc;
          }
        }
        .v-input.v-input--switch.v-input--is-disabled {
          opacity: 0.3;
        }
      }
      &-title {
        h3 {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;
          color: #4b4b4b;
          display: inline;
          margin-right: 10px;
        }
        h6 {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;
          color: #989898;
        }
        .v-input.v-input--switch {
          margin-top: 0;
          padding-top: 0;
          display: inline-block;

          .v-input__control {
            .v-messages {
              display: none;
            }

            .v-input__slot {
              margin-bottom: 0;

              .v-input--selection-controls__input {
                .v-input--switch__track {
                  border-radius: 15px;
                  width: 40px;
                  left: -2px;
                  position: absolute;
                  opacity: 1;
                  right: 2px;
                  top: calc(50% - 12px);
                  height: 20px;
                  color: #cccccc !important;
                }

                .v-input--switch__track.primary--text {
                  color: #0075c2 !important;
                }

                .v-input--switch__thumb {
                  color: #ffffff !important;
                  width: 16px;
                  height: 16px;
                  box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.1);
                }
              }

              .theme--light.v-label {
                font-size: 12px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: 0.6px;
                color: #666;
              }
            }
          }
        }

        .v-input--radio-group {
          margin-top: 0;
          padding-top: 0;

          .v-input__control {
            .v-input__slot {
              margin-bottom: 0;

              .v-input--radio-group__input {
                .v-radio.theme--light {
                  &:last-child {
                    margin-right: 0;
                  }
                }

                .v-label.theme--light {
                  font-size: 12px;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  letter-spacing: 0.6px;
                  color: var(--text-color-2);
                }
              }
            }

            .v-messages.theme--light {
              display: none;
            }

            .v-icon {
              font-size: 20px;

              &.mdi-radiobox-marked {
                color: var(--background-color-3) !important;
              }
            }
          }

          &.custom-radio-inputs {
            .v-input--radio-group__input {
              width: 250px;
              height: 72px;
              flex-direction: column;
            }
          }
        }
      }
    }
  }
  &_content {
    padding-top: 21px;
    max-height: 510px;
    overflow-y: auto;
    & > p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    &:last-child {
      border-bottom: 1px solid #eee;
    }
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    &-details {
      margin-top: 10px;
      h5 {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
  }
  &-collapse {
    cursor: pointer;
    display: inline-block;
    h5 {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &--icon {
      margin-left: 5px;
      color: #c1c1c1 !important;
    }
  }
  &-save {
    margin-top: 16px;
    &.v-btn:not(.v-btn--round).v-size--default {
      width: 120px;
      height: 36px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
    &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #f3f3f3 !important;
      box-shadow: none;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ccc !important;
    }
  }
}
</style>
